import React, { useId, useState } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import classnames from 'classnames';
import styles from './Popover.module.scss';

interface Props {
  trigger: JSX.Element;
  content: JSX.Element;
  classname?: string;
}

export function Popover(props: Props) {
  const { trigger, content, classname } = props;
  const [open, setOpen] = useState(false);
  const contentId = useId();

  return (
    <RadixPopover.Root open={open} onOpenChange={setOpen}>
      <RadixPopover.Anchor asChild>
        {React.cloneElement(trigger, {
          onClick: (event: React.MouseEvent) => {
            (trigger.props as { onClick?: (e: React.MouseEvent) => void }).onClick?.(event);
            setOpen((prev) => !prev);
          },
          'aria-expanded': open,
          'aria-haspopup': 'dialog',
          ...(open && { 'aria-controls': contentId }),
        })}
      </RadixPopover.Anchor>
      <RadixPopover.Portal>
        <RadixPopover.Content id={contentId} className={classnames(styles.popoverContent, classname)}>
          {content}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
